import React, { useMemo } from "react";
import { Descriptions, Typography } from "antd";
import { upperFirst } from "lodash";
import { isoDateToDate } from "../../helpers/helper";
import { getIcon } from "./FuzzyIcon";

const { Text } = Typography;

const isDateKey = (key) => key.toLowerCase().endsWith("date");

const CustomDescription = ({
  heading,
  data = {},
  keys = [],
  extra = null,
}) => {
  const items = useMemo(() => {
    if (!data || !keys.length) return [];

    return keys.map((itemKey) => {
      const value = data[itemKey];

      return {
        key: `${heading}-${itemKey}`,
        label: (
          <div>
            {getIcon(itemKey, true, {
              size: 24,
              title: upperFirst(itemKey),
            })}
          </div>
        ),
        children: isDateKey(itemKey) ? (
          <Text strong>
            {value ? isoDateToDate(value, false) : "-"}
          </Text>
        ) : (
          <Text strong>{value ?? "-"}</Text>
        ),
      };
    });
  }, [data, keys, heading]);

  if (!items.length) return null;

  return (
    <Descriptions
      className="p-2"
      extra={extra}
      style={{ marginBottom: 10 }}
      size="small"
      bordered
      items={items}
      title={heading}
    />
  );
};

export default CustomDescription;
